import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { ShellComponent } from './layout/shell/shell.component';
import {QrScanComponent} from "./pages/qr-scan/qr-scan.component";
import {AuthenticateComponent} from "./pages/authenticate/authenticate.component";
import {RouteGuardService} from "./services/route-guard.service";

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'authenticate', component: AuthenticateComponent},
  {
    path: 'home',
    component: ShellComponent,
    canActivate: [RouteGuardService],
    children: [
      { path: '', redirectTo: 'qr-scan', pathMatch: 'full' },
      { path: 'qr-scan', component: QrScanComponent },
    ],
  },
];
